export const HOTKEYS = {
  assigneePicker: 'a',
  labelPicker: 'l',
  milestonePicker: 'm',
  projectPicker: 'p',
  issueTypePicker: 'i',
}
